import React, { useContext, useState } from 'react';
import styles from './index.module.scss';
import IconRocketImg from './icon-rocket@2x.png';
import { Progress } from 'antd';

import { useRequest } from 'ahooks';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';
import { apiV2MicrogridOverviewGetOptEnginePost } from '@maxtropy/intelligent-dispath-apis-v2';
import { Button } from '@maxtropy/components';
import { DoubleRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useHasPermission } from '@/utils/utils';
import { PermissionsType } from '@/common/permissionsConst';

const OptimizeEngine: React.FC = () => {
  const { microgridId } = useContext(ShareDataContext);
  const [showWindow, setShowWindow] = useState<boolean>(false);
  const hasPermission = useHasPermission(PermissionsType.P_COMPARISONSTRATEGYRETURNS);

  const navigate = useNavigate();

  const { data } = useRequest(
    () => {
      return apiV2MicrogridOverviewGetOptEnginePost({
        id: microgridId,
      });
    },
    {
      ready: !!microgridId,
      refreshDeps: [microgridId],
    }
  );

  return (
    <div>
      <div className={styles.flowingBtn} onClick={() => setShowWindow(!showWindow)}>
        <img src={IconRocketImg} style={{ width: 28 }} alt="" />
        <div className={styles.text}>优化引擎</div>
      </div>
      {showWindow && (
        <div className={styles.modalBox}>
          <div className={styles.titleRow}>
            <div className={styles.title}>优化引擎</div>
            {hasPermission && (
              <Button
                type="link"
                style={{ padding: '0' }}
                onClick={() => {
                  navigate(`/industrial/greenMicrogrid/overview/compare?microgridId=${microgridId}`);
                }}
              >
                策略收益对比
                <DoubleRightOutlined className={styles.translationStyles} />
              </Button>
            )}
          </div>
          <div className={styles.topRow}>
            <div style={{ whiteSpace: 'nowrap' }}>当前执行策略</div>
            {data?.name ? (
              <div className={styles.strategyName}>{data?.name}</div>
            ) : (
              <div className={styles.emptyDesc}>暂无执行中策略</div>
            )}
          </div>
          <div className={styles.chartBox}>
            <div className={styles.processRow}>
              <div className={styles.eachTitle}>最大供电保障权重</div>
              <Progress
                status="active"
                percent={data?.powerSupplyWeight}
                style={{ width: 100 }}
                strokeColor={{ '0%': '#51DBFF', '100%': '#51A1FF' }}
                trailColor="rgba(74,144,226,0.2)"
                showInfo={false}
              />
              <div className={styles.eachPercent}>{data?.powerSupplyWeight}%</div>
            </div>
            <div className={styles.processRow}>
              <div className={styles.eachTitle}>最小用电成本权重</div>
              <Progress
                status="active"
                percent={data?.electricityCostWeight}
                style={{ width: 100 }}
                strokeColor={{ '0%': '#51DBFF', '100%': '#51A1FF' }}
                trailColor="rgba(74,144,226,0.2)"
                showInfo={false}
              />
              <div className={styles.eachPercent}>{data?.electricityCostWeight}%</div>
            </div>
            <div className={styles.processRow}>
              <div className={styles.eachTitle}>最大绿电消纳权重</div>
              <Progress
                status="active"
                percent={data?.greenPowerWeight}
                style={{ width: 100 }}
                strokeColor={{ '0%': '#51DBFF', '100%': '#51A1FF' }}
                trailColor="rgba(74,144,226,0.2)"
                showInfo={false}
              />
              <div className={styles.eachPercent}>{data?.greenPowerWeight}%</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OptimizeEngine;
